import React, { FC, memo } from 'react';
import { Payment } from 'src/redux/slices/customer-payment';
import { Box, Typography } from '@material-ui/core';
import { formatCurrency } from 'src/utils';
interface Props {
  data: Payment[];
}

const Component: FC<Props> = ({ data }) => {
  return (
    <Box>
      {data?.map((payment, index) => (
        <Typography key={`${payment?.payment_type}=${index}`}>
          {`${formatCurrency(payment?.amount)} (${payment?.payment_type})`}
        </Typography>
      ))}
    </Box>
  );
};

export const MOPCell = memo(Component);
